"use client";

import { Link } from "@/i18n/navigation";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { useSearchParams } from "next/navigation";

export default function Breadcrumb({ items = [], textClassName }) {
  if (!items || items.length === 0) return null;

  const searchParams = useSearchParams();

  if (searchParams?.get("hideLayout")) return null;

  return (
    <div className="flex min-w-0 items-center space-x-1 overflow-hidden text-sm">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <div
            key={index}
            className={`flex items-center space-x-1 ${
              isLast ? "min-w-0 flex-shrink" : "flex-shrink-0"
            }`}
          >
            {index > 0 && (
              <div className="flex h-3 w-3 items-center justify-center">
                {" "}
                <FontAwesomeIcon
                  icon={byPrefixAndName.far["chevron-right"]}
                  className="text-primary-muted-subtext !h-[10px] !w-[6px]"
                />
              </div>
            )}

            {!item.href ? (
              <span
                className={clsx(
                  textClassName,
                  isLast
                    ? "text-foreground max-w-[60vw] truncate text-sm/19 font-semibold whitespace-nowrap md:max-w-none"
                    : "text-primary-muted-subtext text-sm/19 font-normal whitespace-nowrap",
                )}
              >
                {item.label}
              </span>
            ) : (
              <Link
                href={item.href}
                title={item.label}
                className={clsx(
                  textClassName,
                  isLast
                    ? "text-foreground max-w-[60vw] truncate text-sm/19 font-semibold whitespace-nowrap md:max-w-none"
                    : "text-primary-muted-subtext text-sm/19 font-normal whitespace-nowrap",
                )}
              >
                {item.label}
              </Link>
            )}
          </div>
        );
      })}
    </div>
  );
}
